import { render, staticRenderFns } from "./AddOfferApplicationDialog.vue?vue&type=template&id=620f4e3b&scoped=true"
import script from "./AddOfferApplicationDialog.vue?vue&type=script&lang=js"
export * from "./AddOfferApplicationDialog.vue?vue&type=script&lang=js"
import style0 from "./AddOfferApplicationDialog.vue?vue&type=style&index=0&id=620f4e3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620f4e3b",
  null
  
)

export default component.exports